/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Input, Button, Badge, Menu, Tag, Spin,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import '../../css/pages/home.css';
import '../../css/pages/customers.css';
import { useHistory } from 'react-router-dom';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchCommissions } from '../actions/p2p';
import NoData from '../../assets/svgs/undraw_No_data_re_kwbl.svg';
import undrawSearch from '../../assets/svgs/undraw_search_re_ttoj.svg';

const Commissions = () => {
  const history = useHistory();
  const [commissions, setCommissions] = useState([]);
  const [total, setTotal] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [fromdate, setFromDate] = useState('2020-08-01');
  const [todate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  const getCommissions = async () => {
    setLoading(true);
    try {
      const response = await fetchCommissions(fromdate, todate);
      setLoading(false);
      setCommissions(response?.data?.data);
    } catch (error) {
      setLoading(false);
      setCommissions([]);
    }
  };

  //   const onSearch = (e) => {

  //   };

  useEffect(() => {
    getCommissions();
  }, []);

  const antIcon = <LoadingOutlined style={{ fontSize: 54 }} spin />;

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            zIndex: '999',
          }}>
          <Spin indicator={antIcon} size="large" />
        </div>
      )}
      <SideNav page="commissions" />
      <main className="body-main">
        <div className="body-main__container">
          <TopNav page="commissions" />

          <div className="row">
            <div className="col">
              {!commissions?.length && loading === false ? (
                <div
                  className="empty-state empty-state-loans"
                  hidden={commissions?.length}>
                  <img src={NoData} alt="Illustration for empty state" />
                  <h3 className="empty-state__title">
                    There are no commissions yet.
                  </h3>
                  {/* <p className="empty-state__subtext">
                    Insurance will show up here once you start lending.
                  </p> */}
                </div>
              ) : null}
              <div
                className="filled--state loans"
                hidden={!commissions?.length && loading === false}>
                <div className="filter-and-search">
                  <div className="filter-box d-flex align-items-center">
                    {/* <div className="search-box">
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search..."
                        onInput={(e) => e.currentTarget.value === '' && onSearch(e)}
                        onKeyDown={(e) => e.key === 'Enter' && onSearch(e)} />
                    </div> */}
                    <div className="form-group mr-2 my-0">
                      <label>From</label>
                      <Input
                        type="Date"
                        value={fromdate}
                        onChange={(e) => setFromDate(
                          moment(e.target.value).format('YYYY-MM-DD'),
                        )} />
                    </div>
                    <div className="form-group mx-3 my-0">
                      <label>To</label>
                      <Input
                        type="Date"
                        value={todate}
                        onChange={(e) => setToDate(moment(e.target.value).format('YYYY-MM-DD'))} />
                    </div>
                    <div className="form-group my-0">
                      <br />
                      <Button
                        type="primary"
                        className="btn-primary border-0 px-3"
                        title="Click to view record"
                        onClick={() => getCommissions()}>
                        View
                      </Button>
                    </div>
                  </div>
                  <div className="filter-and-search d-flex justify-content-end"></div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="card default-card page-table">
                      <div className="empty-state no-result" hidden>
                        <img src={undrawSearch} alt="Illustration for search" />
                        <h3 className="empty-state__title">
                          No results found.
                        </h3>
                        <p className="empty-state__subtext">
                          Please check your spelling or try searching for
                          something different.
                        </p>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="borrower_id">S/N</th>
                              <th className="name text-center">
                                Broker Commission Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {commissions?.map((item, index) => (
                              <tr key={item?.id} role="button">
                                <td
                                  className="select_loan text-nowrap"
                                  onClick={(e) => e.stopPropagation()}>
                                  {(index += 1)}
                                </td>
                                <td className="borrower_id text-nowrap text-center">
                                  {item?.broker_commission_amount}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Commissions;
